<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <h3>Gerenciar limite de lançamento da produção</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-col
          class="px-2 py-0 ma-0"
          v-for="data in system.alerts"
          :key="data.ordem"
          :loading="myloadingvariable"
      >
        <v-alert
            v-model="data.index"
            border="left"
            v-if="data.type == 'success'"
            type="success"
            dismissible
            elevation="10"
        >
          {{ data.message }}
        </v-alert>
        <v-alert
            v-model="data.index"
            border="left"
            v-if="data.type == 'warning'"
            type="warning"
            dismissible
            elevation="10"
        >
          {{ data.message }}
        </v-alert>
      </v-col>
      <v-card-text>
        <v-row>
          <v-col :cols="dynamicCol">
            <v-autocomplete
                v-model="IdUnidadeFiltro"
                :items="unidadesList"
                item-text="Unidade"
                item-value="IdUnidade"
                label="Unidade"
                @change="[getLimite($event)]"
                hide-details
                outlined
                dense
                clearable
            ></v-autocomplete>
          </v-col>
          <v-col :cols="dynamicCol">
            <v-autocomplete
                v-model="IdMes"
                :items="periodosList"
                item-text="Mes"
                item-value="IdMes"
                label="Mês"
                @change="[getLimite($event)]"
                hide-details
                outlined
                dense
                clearable
            ></v-autocomplete>
          </v-col>
          <v-col :cols="dynamicCol">
            <v-select
                v-model="IdAno"
                :items="anoList"
                item-text="IdAno"
                item-value="IdAno"
                label="Ano"
                @change="[getLimite($event)]"
                hide-details
                outlined
                dense
                clearable
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="8" md="9" lg="9" xl="10">
            <v-text-field
                v-model="search"
                prepend-icon="mdi-feature-search-outline"
                label="Pesquisar"
                clearable
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="3" lg="3" xl="2">
            <v-btn
                block
                color="primary"
                class="mt-3"
                @click="
                [
                  (system.modelCadEvento = !system.modelCadEvento),
                  (system.btnlEditEvento = false),
                  clear(),
                ]
              "
                dark
            >
              <v-icon left>mdi-plus</v-icon>
              Novo Limite
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="limiteList"
            :search="search"
            class="elevation-1"
            :loading="myloadingvariable"
            loading-text="Carregando..."
        >
          <template v-slot:[`item.mes`]="{ item }">
            {{mes[item.mes - 1]}}
          </template>
          <template v-slot:[`item.dataLimite`]="{ item }">
            {{ $moment(item.dataLimite).format("L") }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :disabled="item.IdStatusProcesso > 1"
                    icon
                    @click="
                    [
                      (cadastro.mes = item.mes),
                      (cadastro.ano = item.ano),
                      (cadastro.observacao = item.observacao),
                      (cadastro.dataLimite = item.dataLimite),
                      (cadastro.IdUnidade = item.IdUnidade),
                      (cadastro.sequencial = item.sequencial),
                      (system.modelCadEvento = true),
                      (system.btnlEditEvento = true),
                    ]
                  "
                >
                  <v-icon color="orange">mdi-calendar-edit</v-icon>
                </v-btn>
              </template>
              <span>Editar limite</span>
            </v-tooltip>
<!--            <v-tooltip bottom>-->
<!--              <template v-slot:activator="{ on, attrs }">-->
<!--                <v-btn-->
<!--                    v-bind="attrs"-->
<!--                    v-on="on"-->
<!--                    :disabled="item.IdStatusProcesso > 1"-->
<!--                    icon-->
<!--                    @click="[deleteEvento(item.IdAgendamento)]"-->
<!--                >-->
<!--                  <v-icon color="red">mdi-delete</v-icon>-->
<!--                </v-btn>-->
<!--              </template>-->
<!--              <span>Excluir agendamento</span>-->
<!--            </v-tooltip>-->
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- CADASTRO DOS Limites -->
    <v-dialog scrollable width="95%" v-model="system.modelCadEvento" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card :loading="myloadingvariable">
        <v-card-title>
          <v-row>
            <v-col cols="12">
                <h3 v-if="system.btnlEditEvento">Editar Limite</h3>
                <h3 v-else>Novo Limite</h3>
            </v-col>
            <v-col cols="12">
              <v-alert
                  v-if="system.alertError"
                  v-model="system.alertError"
                  dismissible
                  type="error"
              >
                <ul>
                  <li v-for="error in system.alertInfo" :key="error.index">
                    {{ error[0] }}
                  </li>
                </ul>
              </v-alert>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="3">
                <v-autocomplete
                v-model="cadastro.IdUnidade"
                :items="unidadesList"
                item-text="Unidade"
                item-value="IdUnidade"
                label="Unidade"
                :readonly="system.btnlEditEvento">
                </v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                v-model="cadastro.mes"
                :items="periodosList"
                item-text="Mes"
                item-value="IdMes"
                label="Mês"
                :readonly="system.btnlEditEvento">
                </v-autocomplete>
              </v-col>
              <v-col cols="3" v-if="system.btnlEditEvento">
                <v-text-field
                    v-model="cadastro.ano"
                    label="Ano"
                    readonly
                >
                </v-text-field>
              </v-col>
              <v-col cols="3" v-else>
                <v-autocomplete
                    v-model="cadastro.ano"
                    :items="anoList"
                    item-text="IdAno"
                    item-value="IdAno"
                    label="Ano">
                </v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-menu
                    v-model="dateTimes.menuDataLimite"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="cadastro.dataLimite"
                        label="Data Limite"
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        type="date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="cadastro.dataLimite"
                      @input="
                        [
                          (dateTimes.menuDataLimite = false),
                        ]
                      "
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row v-if="system.btnlEditEvento">
              <v-col cols="12">
                <v-textarea
                    auto-grow
                    v-model="cadastro.observacao"
                    class="mr-2 ml-2"
                    outlined
                    label="Observação"
                    required
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="
            [(system.modelCadEvento = !system.modelCadEvento),
              (system.btnlEditEvento = false),
            ]
          "
            large
            dark
          >
            Cancelar
          </v-btn>
          <v-btn
            v-if="system.btnlEditEvento"
            @click="[(updateLimite(cadastro.sequencial))]"
            color="primary"
            large
            dark
          >Atualizar
          </v-btn>
          <v-btn
            v-else
            @click="
            [(createLimite())]"
            color="primary"
            large
            dark
          >Cadastrar

          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ******************** -->
    <AlertSystem :snackbar="system.snackbar"></AlertSystem>
  </v-container>
</template>

<script>
import AlertSystem from "../components/AlertSystem";
import moment from "moment";


export default {
  name: "Limite",
  components:{
    AlertSystem,
  },
  data:() => ({
    headers: [
      { text: 'Unidade', value: 'Unidade', width: '15%'},
      { text: "Mês", value: "mes" },
      { text: "Ano", value: "ano" },
      { text: "Data limite", value: "dataLimite"},
      { text: "Ações", value: "actions", align: "right" },
    ],
    system: {
      opcoesNotificacaoEmail: false,
      modalAnexos: false,
      modelCadEvento: false,
      modelRemoveCredenciado: false,
      btnlEditEvento: false,
      alertError: false,
      alertInfo: null,
      alertAction: null,
      action: "",
      snackbar: {},
      showAlerts: false,
      alerts: [],
    },
    cadastro:{
      IdUnidade: null,
      mes:null,
      ano:null,
      dataLimite:"",
      observacao:"",
      sequencial:null,
    },
    dateTimes: {
      menuDataLimite: false,
    },
    myloadingvariable: false,
    unidadesList: [],
    IdUnidadeFiltro: null,
    periodosList: [
      {
        IdMes: 1,
        Mes: "Janeiro",
      },
      {
        IdMes: 2,
        Mes: "Fevereiro",
      },
      {
        IdMes: 3,
        Mes: "Março",
      },
      {
        IdMes: 4,
        Mes: "Abril",
      },
      {
        IdMes: 5,
        Mes: "Maio",
      },
      {
        IdMes: 6,
        Mes: "Junho",
      },
      {
        IdMes: 7,
        Mes: "Julho",
      },
      {
        IdMes: 8,
        Mes: "Agosto",
      },
      {
        IdMes: 9,
        Mes: "Setembro",
      },
      {
        IdMes: 10,
        Mes: "Outubro",
      },
      {
        IdMes: 11,
        Mes: "Novembro",
      },
      {
        IdMes: 12,
        Mes: "Dezembro",
      },
    ],
    IdMes: null,
    IdAno: null,
    anoList: [
      {
        IdAno: moment().format('YYYY'),
      },
      //ano anterior
      {
        IdAno: moment().format('YYYY')-1,
      }
    ],
    mes : ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    search: "",
    limiteList:[],
    dateObj: null,
  }),
  methods: {
    getUnidades() {
      this.axios("unidades").then((res) => {
        this.unidadesList = res.data;
      });
    },
    getLimite() {
      this.axios("limites", {
        params:{
          IdUnidade: this.IdUnidadeFiltro,
          Mes: this.IdMes,
          Ano: this.IdAno
        }
      })
        .then((res)=> {
        this.limiteList = res.data;
      })
    },
    createLimite() {
      this.axios.post('limites', {
        IdUnidade: this.cadastro.IdUnidade,
        Mes: this.cadastro.mes,
        Ano: this.cadastro.ano,
        DataLimite: this.cadastro.dataLimite
      })
        .then((res) => {
          this.system.snackbar = {
            snackbar: true,
            text: res.data.message,
            color: "green",
          };
          this.getLimite();
          this.system.btnlEditEvento = false;
          this.system.modelCadEvento = !this.system.modelCadEvento;
          this.clear();
        })
          .catch((error) => {
            this.system.alertError = true;
            this.system.alertInfo = error.response.data;
          });
    },
    updateLimite(sequencial) {
        this.axios.post(`limites/${sequencial}`, {
          DataLimite: this.cadastro.dataLimite,
          Observacao: this.cadastro.observacao
        })
            .then((res) => {
              this.system.snackbar = {
                snackbar: true,
                text: res.data.message,
                color: "green",
              };
              this.getLimite();
              this.system.btnlEditEvento = false;
              this.system.modelCadEvento = !this.system.modelCadEvento;
              this.clear();
            })
            .catch((error) => {
              this.system.alertError = true;
              this.system.alertInfo = error.response.data;
            });
    },
    clear(){
      this.cadastro.IdUnidade=null
      this.cadastro.mes=null
      this.cadastro.ano=null
      this.cadastro.dataLimite=""
      this.cadastro.sequencial=null
    }
  },
  mounted(){
    this.getUnidades()
    this.getLimite()
  }
}
</script>

<style scoped>

</style>